import * as React from 'react';

import * as classNames from 'classnames';

import { CircularProgress } from '@emburse/ui-core';

import '../../../../public/styles/abacons.styl';
import * as style from './Spinner.styl';

interface ISpinnerProps {
  loadingText?: string;
  xsmall?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  centered?: boolean;
  usePrimaryColor?: boolean;
}

class Spinner extends React.Component<ISpinnerProps> {
  constructor(props: ISpinnerProps) {
    super(props);
  }

  calculateSize(xsmall: boolean, small: boolean, medium: boolean, large: boolean) {
    if (xsmall) return 16;
    if (small) return 24;
    if (medium) return 32;
    if (large) return 48;
    return null;
  }

  render() {
    const { centered, xsmall, small, medium, large, usePrimaryColor } = this.props;
    const cssClasses = classNames('loader', {
      xsmall,
      small,
      medium,
      large,
      usePrimaryColor
    });
    let size = this.calculateSize(xsmall, small, medium, large);

    return (
      <div data-testid="Spinner" className={style.global + (centered ? ' centered' : '')}>
        <div className={cssClasses}>
          <CircularProgress size={size} />
          <span className="loadingText">{this.props.loadingText}</span>
        </div>
      </div>
    );
  }
}

export { Spinner };
